import api from './api'

export default {
  async getProjectList({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getProjectList(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getProjectConfig({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getProjectConfig(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getProjectTaskList({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getProjectTaskList(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getShopGroupDetail({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getShopGroupDetail(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    commit('updateGroupDetail', res.data)
    return res.data
  },
  async getProjectTaskConfig({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getProjectTaskConfig(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getProjectTaskIncomplete({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getProjectTaskIncomplete(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res
  },
  async getDishesMatchDetail({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getDishesMatchDetail(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    commit('updateDishesRecordInfo', res?.data?.recordInfo || {})
    return res.data
  },
  async getDishMatchList({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getDishMatchList(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async confirmDishMatch({ commit, state }, params) {
    let res = {}
    try {
      res = await api.confirmDishMatch(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
}
